import { put, select, takeLatest } from 'redux-saga/effects'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { saveTimelineItems, setActivityLog } from '../store/timeline.actions'
import { IItem, IItems, ITimelineState } from '../store/timeline.types'
import { TimelineConstants } from '../store/timeline.constants'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { TimesConstants } from '../../times/store/times.constants'
import { ITimesState } from '../../times/store/times.types'
import { getTimesSelector } from '../../times/selectors'

export function* addTimesItem(actionOrSkipSave?: { type: string } | boolean) {
  const skipSave = typeof actionOrSkipSave === 'boolean' ? actionOrSkipSave : false
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { items } = timeline
  const timesState: ITimesState = yield select(getTimesSelector)
  const {
    onsetTime,
    onsetDate,
    receivedTime,
    receivedDate,
    dispatchNotifiedTime,
    dispatchNotifiedDate,
    dispatchedTime,
    dispatchedDate,
    acknowledgedTime,
    acknowledgedDate,
    enRouteTime,
    enRouteDate,
    stagingTime,
    stagingDate,
    onSceneTime,
    onSceneDate,
    atPatientTime,
    atPatientDate,
    transferCareEMSTime,
    transferCareEMSDate,
    leaveReferringTime,
    leaveReferringDate,
    arriveReceivingTime,
    arriveReceivingDate,
    transferCareDestinationTime,
    transferCareDestinationDate,
    availableTime,
    availableDate,
    callCompletedTime,
    callCompletedDate,
    inQuartersTime,
    inQuartersDate,
    cancelledTime,
    cancelledDate,
    firstResponderDate,
    firstResponderTime,
    descentDate,
    descentTime,
    atLandingDate,
    atLandingTime,
    custom1Date,
    custom1Time,
    custom2Date,
    custom2Time,
    custom3Date,
    custom3Time,
    custom4Date,
    custom4Time,
    custom1DateTimeLabel,
    custom2DateTimeLabel,
    custom3DateTimeLabel,
    custom4DateTimeLabel,
  } = timesState

  const item: IItem = {
    itemType: 'Times',
    grid: true,
    rowActionType: TimelineConstants.SET_TIMES_ITEM,
    defaultHref: TabConstants.TIMES_TAB,
    date: new Date(),
  }
  if (cancelledTime || cancelledDate) {
    addToTimeline(items, item, TimesConstants.ADD_CANCELLED_CURRENT_DATETIME, 'Cancelled', cancelledTime, cancelledDate)
  } else {
    deleteFromTimeline(items, TimesConstants.ADD_CANCELLED_CURRENT_DATETIME)
  }
  if (inQuartersTime || inQuartersDate) {
    addToTimeline(
      items,
      item,
      TimesConstants.ADD_IN_QUARTERS_CURRENT_DATETIME,
      'In Quarters',
      inQuartersTime,
      inQuartersDate
    )
  } else {
    deleteFromTimeline(items, TimesConstants.ADD_IN_QUARTERS_CURRENT_DATETIME)
  }
  if (callCompletedTime || callCompletedDate) {
    addToTimeline(
      items,
      item,
      TimesConstants.ADD_CALL_COMPLETED_CURRENT_DATETIME,
      'Call Completed',
      callCompletedTime,
      callCompletedDate
    )
  } else {
    deleteFromTimeline(items, TimesConstants.ADD_CALL_COMPLETED_CURRENT_DATETIME)
  }
  if (availableTime || availableDate) {
    addToTimeline(items, item, TimesConstants.ADD_AVAILABLE_CURRENT_DATETIME, 'Available', availableTime, availableDate)
  } else {
    deleteFromTimeline(items, TimesConstants.ADD_AVAILABLE_CURRENT_DATETIME)
  }
  if (transferCareDestinationTime || transferCareDestinationDate) {
    addToTimeline(
      items,
      item,
      TimesConstants.ADD_TRANSFER_CARE_EMS_CURRENT_DATETIME,
      'Transfer Care Destination',
      transferCareDestinationTime,
      transferCareDestinationDate
    )
  } else {
    deleteFromTimeline(items, TimesConstants.ADD_TRANSFER_CARE_EMS_CURRENT_DATETIME)
  }
  if (arriveReceivingTime || arriveReceivingDate) {
    addToTimeline(
      items,
      item,
      TimesConstants.ADD_ARRIVE_RECEIVING_CURRENT_DATETIME,
      'Arrive Receiving',
      arriveReceivingTime,
      arriveReceivingDate
    )
  } else {
    deleteFromTimeline(items, TimesConstants.ADD_ARRIVE_RECEIVING_CURRENT_DATETIME)
  }
  if (leaveReferringTime || leaveReferringDate) {
    addToTimeline(
      items,
      item,
      TimesConstants.ADD_LEAVE_REFERRING_CURRENT_DATETIME,
      'Leave Referring',
      leaveReferringTime,
      leaveReferringDate
    )
  } else {
    deleteFromTimeline(items, TimesConstants.ADD_LEAVE_REFERRING_CURRENT_DATETIME)
  }
  if (transferCareEMSTime || transferCareEMSDate) {
    addToTimeline(
      items,
      item,
      TimesConstants.ADD_TRANSFER_CARE_EMS_CURRENT_DATETIME,
      'Transfer Care EMS',
      transferCareEMSTime,
      transferCareEMSDate
    )
  } else {
    deleteFromTimeline(items, TimesConstants.ADD_TRANSFER_CARE_EMS_CURRENT_DATETIME)
  }
  if (atPatientTime || atPatientDate) {
    addToTimeline(
      items,
      item,
      TimesConstants.ADD_AT_PATIENT_CURRENT_DATETIME,
      'At Patient',
      atPatientTime,
      atPatientDate
    )
  } else {
    deleteFromTimeline(items, TimesConstants.ADD_AT_PATIENT_CURRENT_DATETIME)
  }
  if (onSceneTime || onSceneDate) {
    addToTimeline(items, item, TimesConstants.ADD_ON_SCENE_CURRENT_DATETIME, 'On Scene', onSceneTime, onSceneDate)
  } else {
    deleteFromTimeline(items, TimesConstants.ADD_ON_SCENE_CURRENT_DATETIME)
  }
  if (stagingTime || stagingDate) {
    addToTimeline(items, item, TimesConstants.ADD_STAGING_CURRENT_DATETIME, 'Staging', stagingTime, stagingDate)
  } else {
    deleteFromTimeline(items, TimesConstants.ADD_STAGING_CURRENT_DATETIME)
  }
  if (enRouteTime || enRouteDate) {
    addToTimeline(items, item, TimesConstants.ADD_EN_ROUTE_CURRENT_DATETIME, 'En Route', enRouteTime, enRouteDate)
  } else {
    deleteFromTimeline(items, TimesConstants.ADD_EN_ROUTE_CURRENT_DATETIME)
  }
  if (acknowledgedTime || acknowledgedDate) {
    addToTimeline(
      items,
      item,
      TimesConstants.ADD_ACKNOWLEDGED_CURRENT_DATETIME,
      'Acknowledged',
      acknowledgedTime,
      acknowledgedDate
    )
  } else {
    deleteFromTimeline(items, TimesConstants.ADD_ACKNOWLEDGED_CURRENT_DATETIME)
  }
  if (dispatchedTime || dispatchedDate) {
    addToTimeline(
      items,
      item,
      TimesConstants.ADD_DISPATCHED_CURRENT_DATETIME,
      'Dispatched',
      dispatchedTime,
      dispatchedDate
    )
  } else {
    deleteFromTimeline(items, TimesConstants.ADD_DISPATCHED_CURRENT_DATETIME)
  }
  if (dispatchNotifiedTime || dispatchNotifiedDate) {
    addToTimeline(
      items,
      item,
      TimesConstants.ADD_DISPATCH_NOTIFIED_CURRENT_DATETIME,
      'Dispatch Notified',
      dispatchNotifiedTime,
      dispatchNotifiedDate
    )
  } else {
    deleteFromTimeline(items, TimesConstants.ADD_DISPATCH_NOTIFIED_CURRENT_DATETIME)
  }
  if (receivedTime || receivedDate) {
    addToTimeline(items, item, TimesConstants.ADD_RECEIVED_CURRENT_DATETIME, 'Received', receivedTime, receivedDate)
  } else {
    deleteFromTimeline(items, TimesConstants.ADD_RECEIVED_CURRENT_DATETIME)
  }
  if (onsetTime || onsetDate) {
    addToTimeline(items, item, TimesConstants.ADD_ONSET_CURRENT_DATETIME, 'Onset', onsetTime, onsetDate)
  } else {
    deleteFromTimeline(items, TimesConstants.ADD_ONSET_CURRENT_DATETIME)
  }
  if (firstResponderTime || firstResponderDate) {
    addToTimeline(
      items,
      item,
      TimesConstants.ADD_FIRST_RESPONDER_DATETIME,
      'First Responder',
      firstResponderTime,
      firstResponderDate
    )
  } else {
    deleteFromTimeline(items, TimesConstants.ADD_FIRST_RESPONDER_DATETIME)
  }
  if (descentTime || descentDate) {
    addToTimeline(items, item, TimesConstants.ADD_DESCENT_CURRENT_DATETIME, 'Descent', descentTime, descentDate)
  } else {
    deleteFromTimeline(items, TimesConstants.ADD_DESCENT_CURRENT_DATETIME)
  }
  if (atLandingTime || atLandingDate) {
    addToTimeline(
      items,
      item,
      TimesConstants.ADD_AT_LANDING_CURRENT_DATETIME,
      'At Landing',
      atLandingTime,
      atLandingDate
    )
  } else {
    deleteFromTimeline(items, TimesConstants.ADD_AT_LANDING_CURRENT_DATETIME)
  }
  if (custom1Time || custom1Date) {
    addToTimeline(items, item, TimesConstants.SET_CUSTOM_1_DATETIME, custom1DateTimeLabel, custom1Time, custom1Date)
  } else {
    deleteFromTimeline(items, TimesConstants.SET_CUSTOM_1_DATETIME)
  }
  if (custom2Time || custom2Date) {
    addToTimeline(items, item, TimesConstants.SET_CUSTOM_2_DATETIME, custom2DateTimeLabel, custom2Time, custom2Date)
  } else {
    deleteFromTimeline(items, TimesConstants.SET_CUSTOM_2_DATETIME)
  }
  if (custom3Time || custom3Date) {
    addToTimeline(items, item, TimesConstants.SET_CUSTOM_3_DATETIME, custom3DateTimeLabel, custom3Time, custom3Date)
  } else {
    deleteFromTimeline(items, TimesConstants.SET_CUSTOM_3_DATETIME)
  }
  if (custom4Time || custom4Date) {
    addToTimeline(items, item, TimesConstants.SET_CUSTOM_4_DATETIME, custom4DateTimeLabel, custom4Time, custom4Date)
  } else {
    deleteFromTimeline(items, TimesConstants.SET_CUSTOM_4_DATETIME)
  }
  yield put(setActivityLog(items))
  if (!skipSave) {
    yield put(saveTimelineItems())
  }
}

export function* addTimesItemSaga() {
  yield takeLatest([TimelineConstants.ADD_TIMES_ITEM], addTimesItem)
}

function addToTimeline(items: IItems, item: IItem, key: string, labelHeader: string, time: string, date: string) {
  const index = items.findIndex((item) => item.key === key)
  const dateTime = new Date(date || 0)
  if (time) {
    if (time.split(':').length >= 3) dateTime.setSeconds(+time.split(':')[2])
    dateTime.setMinutes(+time.split(':')[1])
    dateTime.setHours(+time.split(':')[0])
  }
  const onSetItem: IItem = {
    ...item,
    key,
    labelHeader: time,
    subHeader: date,
    event: labelHeader,
    date: dateTime,
  }
  if (index !== -1) {
    items[index] = onSetItem
  } else {
    items.push(onSetItem)
  }
}
function deleteFromTimeline(items: IItems, key: string) {
  const index = items.findIndex((item) => item.key === key)
  if (index !== -1) {
    items.splice(index, 1)
  }
}
